import React, { PropsWithChildren, ReactElement } from "react";
import styles from "./heroLayout.module.scss";

export const HeroLayout = (props: PropsWithChildren<Props>): ReactElement => {
  return (
    <section className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.left}>{props.children}</div>
        <div className={styles.right}>
          <img src={props.imageUrl} alt="Kunduz" className={styles.image} />
        </div>
      </div>
    </section>
  );
};

interface Props {
  imageUrl: string;
}
